import React from "react";
import Modal from "react-modal";

const SIZES = { sm: "30%", md: "50%", lg: "70%", xl: "90%" };

/**
 * Standard add/edit modal for Masters screens: header with close, body, Save/Close footer.
 * Children render inside the form body; onSubmit receives the submit event already
 * prevented.
 */
export default function MasterModal({
  isOpen,
  title,
  size = "md",
  busy = false,
  saveText = "Save",
  showSave = true,
  onSubmit,
  onClose,
  children,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!busy && onSubmit) onSubmit(e);
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      // Above a slider (MasterDrawer, 1050) so a popup opened from inside one is not hidden behind it;
      // still below confirmations (SweetAlert, 1060) and DevExtreme drop-downs.
      style={{ overlay: { zIndex: 1055 }, content: { width: SIZES[size] ?? size } }}
      className="react-modal mst-modal"
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      contentLabel={title}
    >
      <form onSubmit={handleSubmit} className={busy ? "is-busy" : ""} noValidate>
        <div className="modal-header">
          <h6 className="modal-title">{title}</h6>
          <button type="button" className="close" aria-label="Close" onClick={onClose}>
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">{children}</div>
        <div className="modal-footer">
          {showSave && (
            <button type="submit" className="btn btn-primary btn-sm" disabled={busy}>
              {busy ? (
                <span>
                  <i className="fas fa-spinner fa-spin" /> In-process
                </span>
              ) : (
                <span>
                  <i className="fas fa-check" /> {saveText}
                </span>
              )}
            </button>
          )}
          <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
            <i className="fas fa-times" />
            &nbsp;Close
          </button>
        </div>
      </form>
    </Modal>
  );
}
